import z from "zod";

export const contractDocumentDataSchema = z.object({
  projectId: z.coerce.number().int().positive(),
  contractId: z.coerce.number().int().positive(),
  brand: z.string().optional(),
});

export type ContractDocumentDataProps = z.infer<
  typeof contractDocumentDataSchema
>;
